import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import CONFIG from '../../config';

@Injectable()
export class CommonApiHttpInterceptor implements HttpInterceptor {
  /**
   * Prepends the api base URL from config to the request URL
   * And adds the apikey from config to headers
   */
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith('http')) {
      return next.handle(request);
    }

    const updatedRequest = request.clone({
      url: CONFIG.apiUrl + request.url,
      headers: request.headers.set('apikey', CONFIG.apiKey),
    });

    return next.handle(updatedRequest);
  }
}
